import React, { Suspense, useState } from 'react';
import { Container } from 'components/Page';
import AudienceInput from 'components/Campaign/AudienceInput';
import SelectInput from 'packages/ui/SelectInput';
import RequestAvailableAudience from 'components/Campaign/RequestAvailableAudience';

function Audience() {
  const [channel, setChannel] = useState('email');
  const [filters, setFilters] = useState([]);

  const handleSubmit = formData => {
    const data = formData.filters.map(item => ({
      ...item,
      filter_params: {
        ...item.filter_params
      }
    }));
  };

  return (
    <Container>
      <SelectInput onChange={event => setChannel(event.target.value)} value={channel}>
        <option value="email">ایمیل</option>
        <option value="sms">پیامک</option>
      </SelectInput>

      <AudienceInput channel={channel} onChange={filters => setFilters(filters)} value={filters} />

      <RequestAvailableAudience channel={channel} filters={filters}>
        درخواست آمار دریافت‌کنندگان
      </RequestAvailableAudience>
    </Container>
  );
}

function AudienceForm() {
  return (
    <Suspense fallback={'...'}>
      <Audience />
    </Suspense>
  );
}

export default AudienceForm;
